// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1evLD","content":"styles_content__2zo5b","tableWrap":"styles_tableWrap__3SBdA"};